import { vuexfireMutations, firestoreAction } from "vuexfire";

import { functions, usersCollection, auth, timestamp } from "@/plugins/db";

export default {
  namespaced: true,

  // setup the reactive todos property

  state: {
    loggedIn: null,
    emailVerified: null,
    user: null,
    publicUser: null
  },
  mutations: {
    ...vuexfireMutations,
    SET_LOGIN: (state, user) => {
      state.loggedIn = user.refreshToken;
      state.customClain = user;
      state.emailVerified = user.emailVerified;
    },

    SET_LOGOUT(state) {
      state.loggedIn = null;
      state.emailVerified = null;
      state.user = null;
      localStorage.clear();
    },
    STORE_USUARIO(state, user) {
      state.user = user;
    }
  },
  actions: {
    CALL_DATA: context => {
      return context.dispatch("equipments/bindEquipments", null, {
        root: true
      });
    },
    DELETE_USER: async (context, uid) => {
      try {
        await functions.httpsCallable("deleteUser")(uid);
      } catch (error) {
        console.error(error);
      }
      return "User has been updated";
    },
    COLLECION_USUARIO: (context, form) => {
      return usersCollection.doc(form.uid).set({
        id: form.uid,
        email: form.email,
        firstName: form.firstName,
        lastName: form.lastName,
        role: form.role,
        isMetax: form.isMetax,
        dateCreated: timestamp,
        plant: form.plant
      });
    },
    CREAR_USUARIO: async ({ dispatch }, form) => {
      let usuario = {
        email: form.email,
        password: form.password
      };

      let result = await functions.httpsCallable("newUser")({ usuario });
      let datos = form;
      datos.uid = result.data.uid;
      dispatch("COLLECION_USUARIO", datos);
      return result.data.uid;
    },
    TRAER_USUARIO: firestoreAction((context, uid) => {
      return context.bindFirestoreRef("user", usersCollection.doc(uid));
    }),
    BIND_USER: firestoreAction((context, uid) => {
      return context.bindFirestoreRef("publicUser", usersCollection.doc(uid));
    }),

    SIGN_OUT: async ({ commit }) => {
      let res = await auth.signOut();
      await commit("SET_LOGOUT");
      return res;
    },
    SIGN_IN: async ({ commit, dispatch }, user) => {
      let docRef = await auth.signInWithEmailAndPassword(
        user.email,
        user.password
      );
      await dispatch("CALL_DATA");
      await commit("SET_LOGIN", docRef.user);
      if (!docRef.user.emailVerified) {
        auth.currentUser.sendEmailVerification();
      }
      return docRef;
    }
  },
  getters: {
    emailVerified: state => (state.emailVerified ? true : false),
    isLogged: state => (state.loggedIn ? true : false),
    isEmpty: state => (state.user ? false : true),
    isMetax: state => (state.user?.isMetax ? true : false),
    isVerified: state => (state.emailVerified === true ? true : false),
    isMetric: state => (state.user?.metric === true ? true : false),

    minSupervisor: state =>
      state.user.role === "Admin" || state.user.role === "Supervisor"
        ? true
        : false,
    isSuperAdmin: state => (state.user?.role === "Super Admin" ? true : false),
    isAdmin: state => (state.user?.role === "Admin" ? true : false),
    isSupervisor: state => (state.user?.role === "Supervisor" ? true : false),
    isEngineer: state => (state.user?.role === "Engineer" ? true : false),
    isOperator: state => (state.user?.role === "Operator" ? true : false),
    isReliability: state => (state.user?.role === "Reliability" ? true : false),
    userWrite: state =>
      //state.user?.role === "Supervisor" ||
      state.user?.role === "Super Admin" ||
      state.user?.role === "Admin"
        ? true
        : false,
    adminAndUp: state =>
      state.user?.role === "Super Admin" || state.user.role === "Admin"
        ? true
        : false,
    equipmentWrite: state =>
      state.user?.role === "Supervisor" ||
      state.user?.role === "Super Admin" ||
      state.user?.role === "Admin"
        ? true
        : false,
    logsWrite: state =>
      state.user?.role === "Supervisor" ||
      state.user?.role === "Super Admin" ||
      state.user?.role === "Admin" ||
      state.user?.role === "Engineer"
        ? true
        : false,
    operationsInspectionsWrite: state =>
      state.user?.role === "Engineer" ? false : true,
    reliabilityWrite: state =>
      state.user?.role === "Supervisor" ||
      state.user?.role === "Super Admin" ||
      state.user?.role === "Admin" ||
      state.user?.role === "Reliability"
        ? true
        : false
  }
};
